import {
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt,
  FaFacebook,
  FaTwitter,
  FaLinkedin,
} from "react-icons/fa";
import "./ContactPage.scss";
import ContactForm from "./ContactForm";

const ContactPage = () => {

  return (
    <div className="main_wrapper">
      <div className="container">
        <header className="main-header">
          <h1>Get in Touch</h1>
          <p>
            We're here to help! Send us a message and we'll respond within 24-48
            hours.
          </p>
        </header>

        <section className="contact-content">
          <div className="contact-info">
            <ul>
              <h2>Contact Information</h2>
              <div className="contact-item">
                <FaMapMarkerAlt className="contact-icon" />
                <p> 2900 University Ave #230, West Des Moines, IA 50266</p>
              </div>
              <div className="contact-item">
                <FaPhone className="contact-icon" />
                <p>+1 (515) 254-9494</p>
              </div>
              <div className="contact-item">
                <FaEnvelope className="contact-icon" />
                <p>info@enotesunlimited.com</p>
              </div>

              <div className="social-links">
                <h3>Follow Us</h3>
                <div className="social-icons">
                  <a href="#">
                    <FaFacebook />
                  </a>
                  <a href="#">
                    <FaTwitter />
                  </a>
                  <a href="#">
                    <FaLinkedin />
                  </a>
                </div>
              </div>
            </ul>
          </div>

          <div className="contact-form-section">
            <ContactForm />
          </div>
        </section>
      </div>
    </div>
  );
};

export default ContactPage;
